import React from "react"
import {
    componentStyles,
    VerticalStackStretch,
} from "@mallardbay/lib-react-components"

import COPY from "~config/copy-constants"
import SpeciesCollection from "~components/shared/collections/species-collection"
import { TYPES } from "~components/shared/collections/generic-collection"
import type { SpeciesFieldsFragment } from "~graphql/generated/graphql"
import Divider from "~components/shared/divider"

interface Props {
    readonly species: SpeciesFieldsFragment[] | null | undefined
}

export default function ListingSpecies({ species }: Props) {
    const styles = useStyleProps()

    if (!species?.length) return null

    return (
        <VerticalStackStretch style={styles.root}>
            <SpeciesCollection
                label={COPY.TARGET_SPECIES}
                speciesList={species}
                type={TYPES.SLIDER}
            />
            <Divider />
        </VerticalStackStretch>
    )
}

function useStyleProps() {
    return componentStyles({
        root: {
            gap: 2,
        },
    })
}
